import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function checkBranch(
  ccFormValue: Ref<FormCC>,
  prop: any,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  const requestModel = {
    type: "CC",
    branchCode:
      prop.reminderValue.webFormDetails.oriPrincipalCardDetail.branchName,
  };

  MasterService.checkBranch(requestModel)
    .then((res) => {
      if (!res.data.responseModel.valid) {
        if (
          prop.reminderValue.webFormDetails.oriPrincipalCardDetail
            .deliveryOption == "B"
        ) {
          if (prop.currentStep2 >= 7) jumpStep(7, "", "1");
        }
        if (prop.reminderValue.webFormDetails.oriPrincipalCardDetail) {
          ccFormValue.value.principalDetails.branchValue = "";
          ccFormValue.value.principalDetails.branch = "";
        }
      }
    })
    .catch((e) => {});
}
